import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { ModalInformation } from '@panel/commons/lib/Modals/ModalInformation';

function NormalFlowOffToOnDone(props) {
  const { onClickAction, selectedPlanName } = props;
  const { t } = useTranslation();
  useEffect(() => {
    sendTrackingInfo('Mis avisos', `Republicar Aviso ${selectedPlanName}-Exito`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ModalInformation
      onClickAction={onClickAction}
      onClickOutside={onClickAction}
      title={t('panel.modal.NormalFlowOffToOnDone.title')}
      message={t('panel.modal.NormalFlowOffToOnDone.text')}
      ctaOk={t('panel.modal.cta.ok')}
    />
  );
}

export { NormalFlowOffToOnDone };
